import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { getKeyForEvent } from "./PerformanceEvent";
export function trackPerformanceBreakdown(event) {
    var _getWindow_performance_mark, _getWindow_performance, _getWindow;
    var key = getKeyForEvent(event);
    (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_performance = _getWindow.performance) === null || _getWindow_performance === void 0 ? void 0 : (_getWindow_performance_mark = _getWindow_performance.mark) === null || _getWindow_performance_mark === void 0 ? void 0 : _getWindow_performance_mark.call(_getWindow_performance, key);
}
